const newsletter = require('newsletter/client');
const Carousel = require('client/carousel');
const ItemSlider = require('engine/koa/tutorial/client/itemSlider');

newsletter.initNewsletterForm();

initParticipantsSlider();

const coursesFeedback = document.querySelector('.courses-feedback-inline');

if (coursesFeedback) {
  new Carousel({
    elem: coursesFeedback
  });
}


function initParticipantsSlider() {
  const slider = document.querySelector('[data-participants-slider]');
  if (slider) {
    new ItemSlider({ el: slider });
  }
}
